<template>
  <div class="scanOut">
    <div class="scanToPay">
      <p class="scanTitle">扫码支付</p>
      <span class="scanText">使用微信扫描二维码</span>
      <img :src="imgurl" class="scanImg" />
      <button class="scanClose" @click="back()">关闭</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data () {
    return {
      imgurl: '',
    }
  },
  mounted () {
    this.imgurl = 'https://icmp.shingsou.com/wxPay/captcha?code_url=' + this.$route.query.code_url
  },
  methods: {
    back () {
      // window.open('')
      this.$router.push('/?accessNum=' + this.$route.query.msisdn)
    },
  },
  components: {},
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 550px) {
  .scanToPay {
    width: 90%;
    min-width: 260px;
    height: 530px;
    box-shadow: none;
  }
  .scanOut {
    height: 100%;
    background: none;
  }
  .scanTitle {
    font-size: 20px;
  }
  .scanClose,
  .scanText {
    font-size: 14px;
  }
}
@media screen and (min-width: 550px) and(max-width: 1000px) {
  .scanToPay {
    width: 60%;
    height: 550px;
    box-shadow: 0px 0px 10px rgb(200, 200, 200);
  }
  .scanOut {
    height: 100%;
    background: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/bj_pay.jpg') no-repeat 0px 0px;
    background-size: 100% 100%;
  }
  .scanTitle {
    font-size: 25px;
  }
  .scanClose,
  .scanText {
    font-size: 16px;
  }
}
@media screen and (min-width: 1000px) {
  .scanToPay {
    width: 30%;
    height: 600px;
    box-shadow: 0px 0px 10px rgb(200, 200, 200);
  }
  .scanOut {
    height: 100%;
    background: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newIots/img/bj_pay.jpg') no-repeat 0px 0px;
    background-size: 100% 100%;
  }
  .scanTitle {
    font-size: 30px;
  }
  .scanClose,
  .scanText {
    font-size: 18px;
  }
}
.scanToPay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 25px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  .scanTitle {
    color: #333333;
    font-weight: 500;
    width: 80%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-bottom: 1px #dbdbdb solid;
    margin: 30px 0;
  }
  .scanText {
    color: #006cfb;
  }
  .scanImg {
    // width: 360px;
    width: 70%;
    height: width;
    margin: 10px 0;
  }
  .scanClose {
    border: none;
    color: white;
    width: 23%;
    height: 40px;
    border-radius: 8px;
    background-color: #409eff;
  }
}
</style>
